import styled from 'styled-components';

const Wrapper = styled.div`

  .header {
    display: block; background-color: rgba(35, 31, 32, 1); letter-spacing: 0.07em;
    display: flex;
    justify-content: space-between;
    padding: 0 64px;
  }
  .header-row { display: flex; justify-content: space-between; align-items: center; flex-grow: 1; }
  .header-row:first-child { padding-top: 14px; }
  .header-row:last-child { padding-bottom: 17px; }

  /* Logo */
  .header-row .logo-container { width: 125px; }
  .header-row .logo-container a { display: block; }

  nav { z-index: 99; }

  @media screen and (max-width: 767px) {
      .header { padding: 0 14px; }
      .sign-in { padding: 4px; height: auto; border-radius: 3px; }
  }

  @media screen and (min-width: 768px) and (max-width: 991px) {
      .header { padding: 0 28px; }
  }

  // .header {

  //   .avatarIcon{
  //     height: 33px;
  //     width: 33px;
  //   }
    
  //   padding: 29px 64px;
  //   background-color: rgba(35, 31, 32, 1);
  //   text-align: center;

  //   .logo {
  //     img { height: 56px; }
  //   }

  //   nav {
  //     position: absolute;
  //     top: 48px; right: 64px;
  //     z-index: 1;

  //     // -- Not logged in
  //     button:only-child {
  //       margin: 0;
  //       border: 1px solid rgba(255, 255, 255, 1);
  //       padding: 0;
  //       width: 169px; height: 40px;
  //       background-color: transparent;
  //       line-height: 40px;
  //       font-family: 'Montserrat';
  //       font-size: 14px;
  //       color: rgba(255, 255, 255, 1);
  //       text-align: center;
  //       letter-spacing: 0.08em;
  //       border-radius: 20px;
  //       transform: translateY(-25%);
  //     }
  //     button:only-child:focus, button:only-child:active, button:only-child:hover {
  //       outline-width: 0;
  //       border-color: rgba(35, 31, 32, 1);
  //       background-color: rgba(255, 255, 255, 1);
  //       color: rgba(35, 31, 32, 1);
  //       opacity: 1;
  //     }

  //     // -- Logged in
  //     > div {
  //       display: flex;
  //       align-items: center;
  //       font-family: 'Montserrat';
  //       font-size: 14px;
  //       font-weight: 300;
  //       color: rgba(255, 255, 255, 1);
  //       text-align: center;
  //       letter-spacing: 0.01em;

  //       > div:first-child { margin-right: 20px; }

  //       > div:first-child + div { display: flex; align-items: center; }
  //       .nav-bars {
  //         margin-left: 21px;
  //         span {
  //           display: block;
  //           margin-top: 3px; margin-bottom: 6px;
  //           height: 2px;
  //           width: 26px;
  //           background-color: rgba(255, 255, 255, 1);
  //         }
  //       }
  //     }

  //     // -- nav
  //   }

  //   // -- .header
  // }
  // // .header:after {
  // //   position: absolute;
  // //   right: 0; bottom: -3px; left: 0;
  // //   display: inline-block;
  // //   content: '';
  // //   height: 3px;
  // //   background-color: rgba(12,183,148,1);
  // //   z-index: 1;
  // // }

  

  // @media screen and (max-width: 767px) {
  //   .header {
  //     padding: 16px;
      
  //     nav {
  //       position: static;
  //       top: auto; right: auto;

  //       // -- Not logged in
  //       button:only-child { margin-top: 14px; height: 30px; line-height: 30px; transform: none; }

  //       // -- Logged in
  //       > div {
  //         position: absolute;
  //         top: 16px; right: 16px;

  //         > :first-child { display: none; }
  //       }
  //     }
  //   }
  // }

`;

const PrimaryWrapper = Wrapper.extend`
  .header:after {
    position: absolute;
    right: 0; bottom: -3px; left: 0;
    display: inline-block;
    content: '';
    height: 3px;
    background-color: rgba(12,183,148,1);
    z-index: 1;
  }
`;

export { Wrapper, PrimaryWrapper };


// WEBPACK FOOTER //
// ./src/components/Header/Wrapper.js